import Vue from 'vue';
import utils from '@/utils';

// 先頭にスラッシュを追加する
function addLeadingSlash(string) {
    return string.replace(/^([^/])/, '/$1');
}

// 末尾にスラッシュを追加する
function addTrailingSlash(string) {
    return string.replace(/([^/])$/, '$1/');
}

// 配列をカンマ区切りのテキストにする
function arrayJoin(array, sep = '、') {
    if (!array || !array.length) {
        return;
    }
    return array.join(sep);
}

function dateText(string, format) {
    if (!string) {
        return '';
    }
    return utils.formatDate(string, format);
}

function hyphenToNonBreakingHyphen(string) {
    if (!string) {
        return '';
    }
    return string.replace(/-/g, '‑');
}

// 文字数分の●を返す
function maskedPassword(string, isVisible) {
    if (isVisible) {
        return string;
    }
    let count = string.length;
    let mask = '●';
    return mask.repeat(count);
}

// nullテキストを空欄に変更
function nullToEmpty(string) {
    if (string === null) {
        return;
    }
    return string;
}

// nullテキストを-に変更
function nullToHyphen(string) {
    if (utils.isEmpty(string)) {
        return '-';
    }
    return string;
}

// nullテキストを0に変更
function nullToZero(string) {
    if (string === null) {
        return 0;
    }
    return string;
}

// *100する
function percentage(number) {
    if (number) {
        return number * 100;
    }
    return number;
}

// rankが1以下の時は取得中にする
function rankGetting(rank) {
    if (!utils.isEmpty(rank) && rank < 1) {
        return '-';
    }
    return rank;
}

// 100以上の場合は100位以下にする
function rankText(number) {
    if (number > 100) {
        return '100位以下';
    }
    return number + '位';
}

function removeDomain(string, domain) {
    if (!string) {
        return '';
    }
    let regExp = new RegExp(`^${domain}`);
    return string.replace(regExp, '/').replace(/^\/+/, '/');
}

// 先頭のスラッシュを削除する
function removeLeadingSlash(string) {
    return string.replace(/^\//, '');
}

// 末尾のスラッシュを削除する
function removeTrailingSlash(string) {
    return string.replace(/\/$/, '');
}

// スキーマとディレクトリを排除し、ドメインのみを返す
function getDomain(string) {
    const schemaReg = /^((http|https):\/\/|sc-domain:)/;
    const directoryReg = /\/.*$/;
    return string.replace(schemaReg, '').replace(directoryReg, '');
}

// 指定された数だけstringを繰り返す
function repeatText(string, count) {
    if (!string || !count) {
        return '';
    }
    return string.repeat(count);
}

function replaceDoubleSpaceToSpace(string) {
    if (!string) {
        return '';
    }
    return (
        string
            // eslint-disable-next-line
            .replace(/　/g, ' ')
            .replace(/ +/g, ' ')
    );
}

// 指定した桁数分の小数点を残しつつ数字を丸める
function roundFloatingPointNumber(number, digit) {
    return utils.roundFloatingPointNumber(number, digit);
}

// 指定した桁数分の小数点を残しつつ数字を切り捨てる
function roundDownFloatingPointNumber(number, digit) {
    return utils.roundDownFloatingPointNumber(number, digit);
}

function roundNumber(number) {
    return Math.round(number);
}

// limitを超えた数値はlimit+の形式で返す
function roundNumberText(number, limit) {
    if (number > limit) {
        return limit + '+';
    }
    return number;
}

// 数字を3桁ずつカンマ区切りにする
function separateNumber(number) {
    if (number === null || number === undefined) {
        return number;
    }
    return String(number).replace(/^(-?\d+)(?=\.|$)/, s => {
        return s.replace(/(\d+?)(?=(?:\d{3})+$)/g, '$1,');
    });
}

// 秒数を00:00:00のテキストにする
function secondsToClock(time) {
    if (utils.isEmpty(time)) {
        return;
    }
    let date = new Date(null);
    date.setSeconds(parseInt(time, 10));
    return date.toISOString().substr(11, 8);
}

// 00:00:00のテキストを秒数にする
function clockToSeconds(string) {
    if (!string) {
        return;
    }
    let seconds = 0;
    let array = string.split(':');
    seconds += parseInt(array[0], 10) * 60 * 60;
    seconds += parseInt(array[1], 10) * 60;
    seconds += parseInt(array[2], 10);
    return seconds;
}

// 数字を任意の桁数にする
function zeroPadding(number, digit) {
    digit = digit || 2;
    if (digit >= 2) {
        return (Array(digit).join('0') + number).slice(-digit);
    }
    return number;
}

// 文字列を任意の文字数で短縮する
function truncateText(str, len) {
    let result = 0;
    let text = '';
    for (let i = 0; i < str.length; i++) {
        let chr = str.charCodeAt(i);
        if (
            (chr >= 0x00 && chr < 0x81) ||
            chr === 0xf8f0 ||
            (chr >= 0xff61 && chr < 0xffa0) ||
            (chr >= 0xf8f1 && chr < 0xf8f4)
        ) {
            result += 1;
        } else {
            result += 2;
        }
        if (result <= len) {
            text += str[i];
        } else {
            text += '...';
            break;
        }
    }
    return text;
}

// 数値に指定の数をかけて表示
function numHundred(str, mul) {
    return str.length <= mul ? str : str * mul;
}

// nullテキストを取得中に変更
function truncateNull(str) {
    if (str === null) {
        return '取得中';
    }
    return str;
}

// URLエンコード
function encodeUrl(url) {
    return encodeURIComponent(url);
}

// 9999（圏外）の数値が入った場合11位以下に変更
function truncateOutrank(str) {
    if (str === 9999) {
        return '11位以下';
    } else {
        return str + '位';
    }
}

function truncateRegExp(str, pattern) {
    return str.replace(new RegExp(pattern), '');
}

function taskTitle(str) {
    if (!str) {
        return;
    }
    const array = str.split('\n');
    const title = array.shift();
    return title;
}
function taskBody(str) {
    if (!str) {
        return;
    }
    const array = str.split('\n');
    array.shift();
    const body = array.join('\n');
    return body;
}

Vue.filter('addLeadingSlash', addLeadingSlash);
Vue.filter('addTrailingSlash', addTrailingSlash);
Vue.filter('arrayJoin', arrayJoin);
Vue.filter('dateText', dateText);
Vue.filter('hyphenToNonBreakingHyphen', hyphenToNonBreakingHyphen);
Vue.filter('maskedPassword', maskedPassword);
Vue.filter('nullToEmpty', nullToEmpty);
Vue.filter('nullToHyphen', nullToHyphen);
Vue.filter('nullToZero', nullToZero);
Vue.filter('percentage', percentage);
Vue.filter('rankGetting', rankGetting);
Vue.filter('rankText', rankText);
Vue.filter('removeDomain', removeDomain);
Vue.filter('removeLeadingSlash', removeLeadingSlash);
Vue.filter('repeatText', repeatText);
Vue.filter('removeTrailingSlash', removeTrailingSlash);
Vue.filter('getDomain', getDomain);
Vue.filter('replaceDoubleSpaceToSpace', replaceDoubleSpaceToSpace);
Vue.filter('roundFloatingPointNumber', roundFloatingPointNumber);
Vue.filter('roundDownFloatingPointNumber', roundDownFloatingPointNumber);
Vue.filter('roundNumber', roundNumber);
Vue.filter('roundNumberText', roundNumberText);
Vue.filter('separateNumber', separateNumber);
Vue.filter('secondsToClock', secondsToClock);
Vue.filter('clockToSeconds', clockToSeconds);
Vue.filter('zeroPadding', zeroPadding);
Vue.filter('truncateText', truncateText);
Vue.filter('numHundred', numHundred);
Vue.filter('truncateNull', truncateNull);
Vue.filter('encodeUrl', encodeUrl);
Vue.filter('truncateOutrank', truncateOutrank);
Vue.filter('truncateRegExp', truncateRegExp);
Vue.filter('taskTitle', taskTitle);
Vue.filter('taskBody', taskBody);
